/* This file merges deprecated (hardcoded) and new (figma studio generated) border radius tokens */
import { dimensions } from './tokens'

const radii = {
  // @ts-expect-error - It's already defined in the dimensions.BorderRadius
  none: '0',
  2: '0.125rem',
  4: '0.25rem',
  8: '0.5rem',
  10: '0.625rem',
  12: '0.75rem',
  16: '1rem',
  20: '1.25rem',
  24: '1.5rem',
  32: '2rem',
  // @ts-expect-error - It's already defined in the dimensions.BorderRadius
  full: '100%',
  ...dimensions.BorderRadius,
}

export const getBorderRadius = () => {
  return {
    radii,
  }
}
